/**
 * Zod input schemas: invoices. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
/** AI-read an invoice PDF to pre-fill the form. Base64 PDF bytes; ~10 MB cap
 *  (callable payload limit) — invoices are small. Nothing is stored. */
export const InvoiceParsePdfSchema = z.object({
    pdfBase64: z.string().min(1).max(14_000_000),
    filename: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=invoices.js.map